export default __webpack_public_path__ + "static/23-381c1718952855ca0c7495e55c6779f9.jpg";